module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._t("default"), _vm._v(" "), _c('div', {
    staticClass: "activity-panel"
  }, [_c('ul', {
    staticClass: "box"
  }, _vm._l((_vm.t_data.data), function(item, j) {
    return _c('li', {
      key: j,
      staticClass: "content"
    }, [_c('img', {
      staticClass: "i",
      attrs: {
        "src": item.pics[0]
      }
    }), _vm._v(" "), _c('a', {
      staticClass: "cover-link",
      on: {
        "click": function($event) {
          return _vm.openProduct(item.item_id)
        }
      }
    })])
  }), 0)])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-f708cb50","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/plugins/panel.vue
// module id = 797
// module chunks = 0 1 3